import { useEffect, useState } from "react";
import {useGetFullAddress,useGetDistrict,useGetProvince,useGetSubDistrict,} from "src/api/site";
import InputImage from "../input-image";
import InputNormal from "../input-normal";
import InputLatLng from "../input-latlng";
import { useTranslation } from 'react-i18next'
import DateImplementationSelector from "../../ui/DateImplementationSelector";

function InputSiteDetailBox(props) {
  const THAILAND_COUNTRY_ID = 1; // Thailand country id (for now only one country is used)
  const [selectedProvinceId, setSelectedProvinceId] = useState(null);
  const [selectedDistrictId, setSelectedDistrictId] = useState(null);
  const [selectedSubDistrictId, setSelectedSubDistrictId] = useState();
  const { t } = useTranslation("settings");
  
  const [detailSite, setDetailSite] = useState({
    Id: "",
    No: "",
    NameEn: "",
    NameTh: "",
    Type: "",
    TypeId: "",
    Description: "",
    Address: "",
    Image: "",
    ImageId: 0,
    ImageFile: null,
    ImageFileName: "",
    Latitude: "",
    Longitude: "",
    config: ""
  });

  const { fullAddress } = useGetFullAddress(detailSite?.Address?.id)
  const { provinceList } = useGetProvince(THAILAND_COUNTRY_ID);
  const { districtList } = useGetDistrict(selectedProvinceId || fullAddress?.province);
  const { subDistrictList } = useGetSubDistrict(selectedDistrictId || fullAddress?.district);
 
  const [textHeader, setTextHeader] = useState("");
  const [listInputRequired, setListInputRequired] = useState({
    Name: false,
    Latitude: false,
    Longitude: false,
    Province: false,
    District: false,
    SubDistrict: false
  });
  const [isAddMore, setIsAddMore] = useState(false);
  const [detailLatLng, setDetailLatLng] = useState({
    Latitude: '',
    Longitude: '',
  });

  useEffect(() => {
    setDetailSite(props.detailSite);

    setTextHeader(props.isEdit ? `${t('site_management.edit_site')}` : `${t('site_management.add_site')}`);
    
  }, [props.detailSite,props.isEdit]);
  
  useEffect(() => {
    let detailRequired = {
      ...listInputRequired,
    };
    Object.keys(detailRequired).forEach((key, index) => {
      detailRequired[key] = false;
    });
    let listX = props.alertRequiredField;
    if (Array.isArray(listX)) {
      for (let item of listX) {
        if (detailRequired[item] != undefined) {
          detailRequired[item] = true;
        }
      }
    }
    setListInputRequired(detailRequired);
  }, [props.alertRequiredField]);

  useEffect(() => {
    const latitudeFilled = !!detailSite.Latitude; // Check if Latitude is filled
    const longitudeFilled = !!detailSite.Longitude; // Check if Longitude is filled

    setListInputRequired((prevState) => ({
      ...prevState,
      Latitude: !latitudeFilled,
      Longitude: !longitudeFilled,
    }));
  }, [detailSite.Latitude, detailSite.Longitude]);

  //==============================
  function onSetImage(param) {
    let detail = {
      ...detailSite,
      mainImage: param,
      Image: param.Path,
      ImageFile: param.File,
      ImageFileName: param.File.name,
    };
    setDetailSite(detail);
    try {
      props.onChangeDetail(detail);
    } catch {}
  }

  function onInputDetailSite(key, param) {
    let detail = {
      ...detailSite,
    };
    if (key === "LatLng") {
      detail.Latitude = param.Latitude;
      detail.Longitude = param.Longitude;
    } else if (key === "Type") {
      detail.Type = param.Name;
      detail.TypeId = param.Id;
    } else {
      detail[key] = param;
    }
    setDetailSite(detail);
    try {
      props.onChangeDetail(detail);
    } catch {}
  }

  

  function onInputDetailLatLng(param) {
    let detail = {
        ...detailLatLng
    }
    detail.Latitude = param.Latitude;
    detail.Longitude = param.Longitude;
    setDetailLatLng(detail);
}
 
  const handleProvinceChange = (e) => {
    const selectedId = e.target.value;
    onInputDetailSite("province", selectedId);
    setSelectedProvinceId(selectedId);
    setSelectedDistrictId(null);
    setSelectedSubDistrictId(null);
  };

  const handleDistrictChange = (e) => {
    const selectedId = e.target.value;
    onInputDetailSite("district", selectedId);
    setSelectedDistrictId(selectedId);
    setSelectedSubDistrictId(null);
  };

  const handleSubDistrictChange = (e) => {
    const selectedId = e.target.value;
    onInputDetailSite("sub_district", selectedId);
    setSelectedSubDistrictId(selectedId);
  };

  const plantConfig = detailSite?.config ? JSON.parse(detailSite?.config): {}
  let plantLocation = {};
  try {
    // First parse
    const firstParse = detailSite?.location ? JSON.parse(detailSite.location) : {};
    
    try {
      // Second parse
      plantLocation = JSON.parse(firstParse);
    } catch (e) {
      plantLocation = firstParse;
    }
  } catch (e) {
    plantLocation = {}; 
  }

  const location = plantLocation;


  return (
    <div className="w-full px-4 pb-4 bg-white rounded-lg shadow-content-box">
      <div className="w-full h-[88px] flex items-center justify-between">
        <div>
          <div className="w-40">
            <p className={`text-black text-xl font-bold`}>{textHeader}</p>
          </div>
        </div>

        {/* {showAlert && (
              <div className="text-sm alert alert-danger text-danger" role="alert">
                Latitude and Longitude are required.
              </div>
        )} */}

        <button
          onClick={() => setIsAddMore(!isAddMore)}
          className="px-4 py-2 text-sm text-white rounded-lg bg-vekin-primary"
        >
          {t('site_management.add_more')}
        </button>
      </div>

      <div className="w-full h-px bg-quartenary"></div>

      <div className="flex w-full pt-6">
        <div>
          <div className="w-40 h-40">
            <InputImage
              image={detailSite?.Image}
              onInputImage={(e) => {
                onSetImage(e);
              }}
            />
          </div>
        </div>

        <div className="w-full pl-4">
          <p className={`text-secondary text-sm font-normal mb-3.5`}>
            {t('site_management.site_info')}
          </p>

          <div className="grid w-full grid-cols-3 gap-4 mt-4 mb-2 gap-y-2">
            <div className="col-span-3">
              <InputNormal
                type="text"
                keyName={`${t('site_management.site_name')}`}
                placeholder={t('site_management.placeholder_name')}
                require={true}
                alert={listInputRequired["Name"]}
                value={detailSite.NameEn}
                onInputText={(e) => {
                  onInputDetailSite("NameEn", e);
                }}
              />
            </div>
            <div className="flex w-full col-span-3">
              <InputNormal
                type="text"
                keyName={`${t('site_management.site_description')}`}
                placeholder={t('site_management.placeholder_description')}
                require={false}
                value={detailSite.Description}
                onInputText={(e) => {
                  onInputDetailSite("Description", e);
                }}
              />
            </div>
            <div className="col-span-2">
              <InputNormal
                keyName={`${t('site_management.building_name')}`}
                placeholder={t('site_management.placeholder_building_name')}
                type="text"
                className="text-primary "
                containerStyle="col-span-2"
                maxLength={55}
                require={true}
                alert={listInputRequired["Building Name"]}
                value={ detailSite?.building_name ||detailSite?.Address?.building_name ||fullAddress?.building_name }
                onInputText={(e) => {
                  onInputDetailSite("building_name", e);
                }}
              />
            </div>
            <InputNormal
              keyName={`${t('site_management.address_no')}`}
              type="text"
              require={true}
              className="text-primary"
              placeholder={t('site_management.placeholder_address_no')}
              alert={listInputRequired["Address Number"]}
              value={detailSite?.address_no ||detailSite?.Address?.address_no ||fullAddress?.address_no }
              onInputText={(e) => {
                onInputDetailSite("address_no", e);
              }}
            />
            <InputNormal
              keyName={`${t('site_management.moo_no')}`}
              type="number"
              require={true}
              className="text-primary"
              placeholder={t('site_management.placeholder_moo_no')}
              alert={listInputRequired["Moo number"]}
              value={ detailSite?.moo_no || detailSite?.Address?.moo_no ||fullAddress?.moo_no}
              onInputText={(e) => {
                onInputDetailSite("moo_no", e);
              }}
            />
            <InputNormal
              keyName={`${t('site_management.floor_no')}`}
              type="number"
              require={true}
              className="text-primary"
              placeholder={t('site_management.placeholder_floor_no')}
              alert={listInputRequired["floor number"]}
              value={ detailSite.floor_no ||detailSite?.Address?.floor_no ||fullAddress?.floor_no}
              onInputText={(e) => {
                onInputDetailSite("floor_no", e);
              }}
            />
            <InputNormal
              keyName={`${t('site_management.room_no')}`}
              type="number"
              require={true}
              className="text-primary"
              placeholder={t('site_management.placeholder_room_no')}
              alert={listInputRequired["Room number"]}
              value={ detailSite?.room_no || detailSite?.Address?.room_no ||fullAddress?.room_no}
              onInputText={(e) => {
                onInputDetailSite("room_no", e);
              }}
            />
          </div>

          <div className="grid grid-cols-3 gap-4 gap-y-2">
            <InputNormal
              keyName={`${t('site_management.soi')}`}
              type="text"
              require={true}
              className="text-primary"
              placeholder={t('site_management.placeholder_soi')}
              alert={listInputRequired["soi"]}
              value={detailSite?.soi || detailSite?.Address?.soi || fullAddress?.so }
              onInputText={(e) => {
                onInputDetailSite("soi", e);
              }}
            />
            <InputNormal
              keyName={`${t('site_management.road')}`}
              type="text"
              require={true}
              className="text-primary"
              placeholder={t('site_management.placeholder_road')}
              alert={listInputRequired["road_name"]}
              value={detailSite?.road_name ||detailSite?.Address?.road_name ||fullAddress?.road_name }
              onInputText={(e) => {
                onInputDetailSite("road_name", e);
              }}
            />
            <div className="w-full h-14 rounded px-2 py-1.5 border border-solid">
              <p className="text-xs font-normal text-secondary">{t('site_management.province')}</p>
              <select
                value={ selectedProvinceId || fullAddress?.province || detailSite?.Address?.province }
                require={true}
                onChange={handleProvinceChange}
                className="w-full text-sm text-vekin-primary focus:outline-0"
              >
                <option>{t('site_management.placeholder_province')}</option>
                {provinceList?.map((province) => (
                  <option key={province?.value} value={province?.value}>
                    {province?.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="w-full h-14 rounded px-2 py-1.5 border border-solid">
              <p className="text-xs font-normal text-secondary">{t('site_management.district')}</p>
              <select
                value={ selectedDistrictId || fullAddress?.district || detailSite?.address?.district }
                require={true}
                onChange={handleDistrictChange}
                className="w-full text-sm text-vekin-primary focus:outline-0"
              >
                <option>{t('site_management.placeholder_district')}</option>
                {districtList?.map((district) => (
                  <option key={district?.value} value={district?.value}>
                    {district?.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="w-full h-14 rounded px-2 py-1.5 border border-solid">
              <p className="text-xs font-normal text-secondary">{t('site_management.sub_district')}</p>
              <select
                value={ selectedSubDistrictId ||fullAddress?.sub_district || detailSite?.Address?.sub_district }
                require={true}
                onChange={handleSubDistrictChange}
                className="w-full text-sm text-vekin-primary focus:outline-0"
              >
                <option>{t('site_management.placeholder_sub_district')}</option>
                {subDistrictList?.map((subDistrict) => (
                  <option key={subDistrict?.value} value={subDistrict?.value}>
                    {subDistrict?.label}
                  </option>
                ))}
              </select>
            </div>
            <InputNormal
              keyName={`${t('site_management.postal_code')}`}
              type="number"
              className="text-primary"
              placeholder={t('site_management.placeholder_postal_code')}
              value={fullAddress?.post_code}
            />
          </div>

          <div className="my-2" >
            <InputLatLng 
              require={false} 
              valueLat={detailSite?.Latitude}
              valueLng={detailSite?.Longitude}
              onInputText={(e) => { onInputDetailLatLng(e) }}
            />
          </div>

          {isAddMore && (
            <div className="grid w-full grid-cols-3 gap-4 my-2 gap-y-2">
              <div>
                <InputNormal
                  type="text"
                  keyName={`${t('site_management.business_type')}`}
                  placeholder={t('site_management.placeholder_business_type')}
                  value={plantConfig?.business_type}
                  onInputText={(e) => {
                    onInputDetailSite("business_type", e);
                  }}
                />
              </div>
              <div>
                <InputNormal
                  type="text"
                  keyName={`${t('site_management.landlord')}`}
                  placeholder={t('site_management.placeholder_landlord')}
                  value={plantConfig?.landlord}
                  onInputText={(e) => {
                    onInputDetailSite("landlord", e);
                  }}
                />
              </div>
              <div>
                <InputNormal
                  type="text"
                  keyName={`${t('site_management.branch_code')}`}
                  placeholder={t('site_management.placeholder_branch_code')}
                  require={false}
                  alert={listInputRequired["plant_code"]}
                  value={plantConfig?.plant_code}
                  onInputText={(e) => {
                    onInputDetailSite("plant_code", e);
                  }}
                />
              </div>
              <div>
                <div className="w-full h-14 rounded px-2 py-1.5 border border-solid border-quartenary">
                  <div className="flex">
                    <p className="text-xs font-normal text-secondary">
                      {t('site_management.date_of_implementation')}
                    </p>
                    {false && <p className="text-xs font-normal text-secondary">&nbsp;*</p>}
                  </div>
                  <DateImplementationSelector
                    selectedDate={plantConfig?.date_of_implementation ? new Date(plantConfig.date_of_implementation) : null}
                    onDateChange={(date) => {
                      onInputDetailSite("date_of_implementation", date);
                    }}
                  />
                </div>
                {listInputRequired["date of implementation"] && (
                  <p className="text-xs text-danger">
                    {t('site_management.please_enter_date_of_implementation')}
                  </p>
                )}
              </div>
              <div>
                <InputNormal
                  type="number"
                  keyName={`${t('site_management.taxpayer')}`}
                  placeholder={t('site_management.placeholder_taxpayer')}
                  require={false}
                  value={plantConfig?.tax_id}
                  onInputText={(e) => {
                    onInputDetailSite("tax_id", e);
                  }}
                />
              </div>
              <div>
                <InputNormal
                  type="file"
                  keyName={`${t('site_management.attached_file')}`}
                  placeholder={t('site_management.placeholder_attached_file')}
                  require={false}
                  value={plantConfig?.attachedFile}
                  onInputText={(e) => {
                    onInputDetailSite("attachedFile", e);
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default InputSiteDetailBox;
